import * as React from "react";
import styled from "styled-components";
import { Col, Row } from "common/components";
import { Alert } from "components/bootstrap";
import { MarkdownPreview } from "components/common/MarkdownEditor";
import AssocEntities from "./AssocEntities";
import StepListView from "./StepListView";
const SectionHeaderRow = styled(Row)`
  border-bottom: 1px solid ${({ theme }) => theme.colors.input.border};
  padding-bottom: ${({ theme }) => theme.spacings.sm};
`;
function EventProcedureDetailsView({
  eventProcedure,
  descriptionMaxHeight = 250,
  row = false,
  withAssocEntities = false,
  eventId = void 0
}) {
  var _a, _b;
  const Container = row ? Row : Col;
  return /* @__PURE__ */ React.createElement(Container, { $align: "stretch" }, /* @__PURE__ */ React.createElement(Col, null, /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, "Description")), (eventProcedure == null ? void 0 : eventProcedure.description) ? /* @__PURE__ */ React.createElement(
    MarkdownPreview,
    {
      show: true,
      maxHeight: descriptionMaxHeight,
      noBackground: true,
      noBorder: true,
      value: eventProcedure.description,
      noPadding: true
    }
  ) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, "No description set")), /* @__PURE__ */ React.createElement(Col, null, withAssocEntities && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, "Associated Entities")), ((_a = eventProcedure == null ? void 0 : eventProcedure.associated_entities) == null ? void 0 : _a.entity_count) > 0 ? /* @__PURE__ */ React.createElement(AssocEntities, { associatedEntities: eventProcedure.associated_entities }) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, "No associated entites")), /* @__PURE__ */ React.createElement(SectionHeaderRow, null, /* @__PURE__ */ React.createElement("h5", null, "Event Procedure Steps")), ((_b = eventProcedure == null ? void 0 : eventProcedure.steps) == null ? void 0 : _b.length) > 0 ? /* @__PURE__ */ React.createElement(StepListView, { steps: eventProcedure.steps, eventId }) : /* @__PURE__ */ React.createElement(Alert, { style: { width: "100%" } }, "No steps added")));
}
export default EventProcedureDetailsView;
